/* eslint-disable */
/* tslint:disable */

/** getAbortedPoolShifts
 * method: get
 * summary: Get the late canceled shifts and no show shifts of a hubler in the last 3 months for pool shifts
 */

import type {
  GetAbortedPoolShiftsResponseDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/shifts/aborted/pool`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/shifts/aborted/pool`

export type GetAbortedPoolShiftsSuccess = GetAbortedPoolShiftsResponseDto
export type GetAbortedPoolShiftsError = ApiResponseDto
